<template>
    <div :class="{ sectionConfirmOtp: step === 2 }">
        <div class="loading-full-page" v-if="isLoadingPage">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
        </div>
        <template v-else>
            <SideBar v-if="step === 1">
                <div class="personal-detail">
                    <div class="personal-detail__title t-transform-cap">
                        <img
                            class="icon-back"
                            src="@/assets/images/card/back.png"
                        />
                        {{ getTranslatedText("Personal Details") }}
                        <img
                            class="icon-dropdown"
                            @click="onShowBottomMenuList"
                            src="@/assets/images/header/dropdown-icon.png"
                        />
                    </div>
                    <div class="personal-detail__container">
                        <div class="personal-detail__avatar">
                            <ImageInput
                                @reloadAvatar="reloadAvatar"
                                v-model="avatar"
                                @CaptureFromCamera="toggleCamera"
                                :is-open-popup="isOpenPopupOptionAvatar"
                                @changeShowPopup="togglePopupOptionsAvatar"
                                @showToast="
                                    showToast($event.message, $event.type)
                                "
                            >
                                <div slot="activator" class="personal-detail__avatar__camera-open">
                                    <div
                                        class="personal-detail__avatar__circle"
                                        v-if="!avatar && !isCameraOpen"
                                    >
                                        <v-avatar
                                            v-if="$store.state.srcAvatar !== ''"
                                            size="131px"
                                            v-ripple
                                            class="mb-3"
                                        >
                                            <img :src="$store.state.srcAvatar" />
                                        </v-avatar>
                                        <img
                                            v-if="$store.state.srcAvatar === ''"
                                            src="@/assets/images/personal-detail/avatar.png"
                                        />
                                        <div
                                            class="personal-detail__avatar__edit"
                                        >
                                            <img
                                                src="@/assets/images/personal-detail/edit-avatar.png"
                                            />
                                        </div>
                                    </div>
                                    <v-avatar
                                        size="131px"
                                        v-ripple
                                        v-else
                                        class="mb-3"
                                    >
                                        <img
                                            v-if="!isCameraOpen"
                                            :src="avatar.imageURL"
                                            alt="avatar"
                                        />
                                        <div
                                            v-if="isCameraOpen"
                                            v-show="!isLoading"
                                            :class="{ flash: isShotPhoto }"
                                        >
                                            <div
                                                class="camera-shutter"
                                                :class="{ flash: isShotPhoto }"
                                            ></div>

                                            <video
                                                v-show="!isPhotoTaken"
                                                ref="camera"
                                                :width="155"
                                                :height="155"
                                                autoplay
                                            ></video>

                                            <canvas
                                                v-show="isPhotoTaken"
                                                id="photoTaken"
                                                ref="canvas"
                                                :width="131"
                                                :height="131"
                                            ></canvas>
                                        </div>
                                    </v-avatar>
                                    <div
                                        v-show="isCameraOpen && isLoading"
                                        class="camera-loading"
                                    >
                                        <ul class="loader-circle">
                                            <li></li>
                                            <li></li>
                                            <li></li>
                                        </ul>
                                    </div>
                                    <div
                                        v-if="isCameraOpen && !isLoading"
                                        class="button-camera"
                                    >
                                        <button
                                            type="button"
                                            class="button-camera__save t-transform-cap"
                                            @click="takePhoto"
                                        >
                                            {{ getTranslatedText("save") }}
                                        </button>
                                        <button
                                            type="button"
                                            class="button-camera__cancel t-transform-cap"
                                            @click="toggleCamera"
                                        >
                                            {{ getTranslatedText("cancel") }}
                                        </button>
                                    </div>
                                </div>
                            </ImageInput>
                        </div>

                        <FormCommon
                            :formItem="formItem"
                            :dataForm="dataForm"
                            @on-bur-input="onBurInputFormData"
                            @update-form-data="updateFormData"
                            @onSubmitForm="onSubmitForm"
                        >
                            <div
                                slot="desMethosRes"
                                class="des-method-register"
                            >
                                <img src="@/assets/images/info.png" />
                                <p class="description t-fir-transform-cap">
                                    {{
                                        getTranslatedText(
                                            "email or mobile number mandatory"
                                        )
                                    }}
                                </p>
                            </div>
                            <b-input-group-prepend
                                slot="propend-phone-number"
                                class="phone-code"
                            >
                                <button
                                    class="show-dropdown-personal-detail"
                                    type="button"
                                    @click="showDropDow"
                                >
                                    <img
                                        class="user-avatar"
                                        :src="
                                            require(`@/assets/images/flags/${dataForm.flag}`)
                                        "
                                        :alt="dataForm.flag"
                                    />
                                    <span class="name-country">{{
                                        dataForm.nameCountry
                                    }}</span>
                                    ({{ dataForm.calling_code }})
                                </button>
                                <b-dropdown ref="select_phone_code">
                                    <b-form-input
                                        v-model="textSearchPhoneNumber"
                                        :placeholder="
                                            getTranslatedText('search')
                                        "
                                        @input="onChangeFilterPhoneNumbers"
                                    ></b-form-input>
                                    <b-dropdown-item
                                        @click="selectPhoneCode(item)"
                                        v-for="(
                                            item, index
                                        ) in phoneNumbersFilter"
                                        :key="index"
                                    >
                                        <div>
                                            <img
                                                class="user-avatar"
                                                :src="
                                                    require(`@/assets/images/flags/${item.flag}`)
                                                "
                                                :alt="item.flag"
                                            />
                                            <span class="name-country">{{
                                                item.name
                                            }}</span>
                                            ({{ item.number }})
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <img
                                    class="dropdown-phone-icon"
                                    src="@/assets/images/personal-detail/dropdown-black.png"
                                />
                            </b-input-group-prepend>
                            <template slot="birthDate">
                                <DateDropdown :default="dataForm.dob" label="date of Birth" :setDefault=false  min="1920" :max="maxYearBirth" @input="updateDate" :textInvalidFeedback="textInvalidFeedbackDate"/>
                            </template>
                            <div class="personal-detail__box-btn" slot="button">
                                <ButtonCustom
                                    :isLoading="isDisabledBtnSave"
                                    classBtn="personal-detail-btn-save"
                                    typeBtn="submit"
                                    type="primary"
                                    text="save"
                                />
                            </div>
                        </FormCommon>
                    </div>
                    <div class="personal-detail__container no-padding">
                        <div class="personal-detail__line">
                            <!--            <img src="@/assets/images/personal-detail/line.png"/>-->
                        </div>
                        <div class="personal-detail__menus">
                            <div
                                @click="changePassword"
                                class="personal-detail__menus__change-password t-transform-cap"
                            >
                                {{ getTranslatedText("change password") }}
                                <img
                                    src="@/assets/images/common/arrow-right-green.png"
                                />
                            </div>
                            <div
                                @click="handleLogout"
                                class="personal-detail__menus__logout t-transform-cap"
                            >
                                {{ getTranslatedText("log out") }}
                                <img
                                    src="@/assets/images/common/arrow-right-green.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </SideBar>
            <div class="section-confirm-otp">
                <ConfirmOTP
                    v-if="step === 2"
                    :dataSource="dataForm"
                    :isLoadingButton="isLoadingButtonOTP"
                    :textBtnContinue="getTranslatedText('done')"
                    @onClickGoBack="onClickGoBack"
                    :methodsChangeInfo="dataForm.otp_by"
                    @onSubmitForm="onSubmitConfirmOTP"
                    @sendOTP="onSubmitForm('resend')"
                    :text="getTranslatedText('enter otp')"
                />
            </div>
        </template>

        <vue-bottom-sheet
            max-height="90%"
            ref="bottomMenuList"
            max-width="100%"
        >
            <BottomSheet :isHiddenBtn="true">
                <template slot="body-sheet">
                    <ul class="bottom-sheet-list-navigation__menu-list">
                        <li
                            v-for="(item, index) in listMenuNavigation"
                            :key="index"
                            v-show="item.isShow"
                            class="bottom-sheet-list-navigation__menu-item"
                        >
                            <div
                                @click="handleClickRedirect(item)"
                                class="bottom-sheet-list-navigation__menu-item-content t-transform-cap"
                            >
                                <img
                                    class="user-avatar"
                                    :src="
                                        require(`@/assets/images/navigation/${item.icon}`)
                                    "
                                    :alt="item.icon"
                                />
                                {{ getTranslatedText(item.title) }}
                            </div>
                        </li>
                    </ul>
                </template>
            </BottomSheet>
        </vue-bottom-sheet>
        <Toast :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>
import { listMenuNavigation } from "@/resources/listNavigation";
import { phoneNumbers } from "@/resources/phoneNumber";
import {
    filterFullTextSearch,
    isStrEmpty,
    redirectPathApp,
    validateEmail,
} from "@/components/common/utils";
import { setUserInfo } from '@/services/axios';

import LanguageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin"

import authService from "@/services/auth.service";
import UserService from "@/services/user.service";
import AuthService from "@/services/auth.service";
import UserAuthenticate from "@/services/user.service";
import countriesService from "@/services/countries.service";
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import ImageInput from "@/components/common/image-input";
import SideBar from "@/components/common/sidebar/SideBar";
import BottomSheet from "@/components/common/bottom-sheet";
import ConfirmOTP from "@/views/mobile/authenticate/ConfirmOTP";
import Toast from "@/components/common/toast/Toast.vue";
import DateDropdown from "@/components/common/date-dropdown/DateDropdown.vue"

import moment from "moment";

export default {
    mixins: [LanguageMixin, RouterMixin],
    components: {
        FormCommon,
        ButtonCustom,
        ImageInput,
        ConfirmOTP,
        SideBar,
        BottomSheet,
        Toast,
        DateDropdown
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            isOpenPopupOptionAvatar: false,
            listMenuNavigation,
            isDisabledBtnSave: false,
            isChangedEmail: false,
            isChangedPhone: false,
            step: 1,
            isLoadingButtonOTP: false,
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            isLoadingPage: true,
            link: "#",
            maxYearBirth: "0",
            maxDate: '',
            textInvalidFeedbackDate: '',
            dataForm: {
                full_name: "",
                gender: "",
                calling_code: "",
                code: "",
                flag: "",
                phone: "",
                email: "",
                nationality: "",
                country_code: "",
                dob: "",
                otp_by: "",
                code_otp: "",
                nameCountry: "",
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "first | middle (optional) | last",
                    name: "full_name",
                    required: true,
                    label: `full name`,
                    for: "input-full-name",
                    id: "input-full-name",
                },
                {
                    type: "radio",
                    name: "gender",
                    required: false,
                    label: `gender`,
                    id: "input-gender",
                    options: [
                        { text: this.getTranslatedText("male"), value: "male" },
                        {
                            text: this.getTranslatedText("female"),
                            value: "female",
                        },
                        {
                            text: this.getTranslatedText("not specify"),
                            value: "not-specify",
                        },
                    ],
                },
                {
                    type: "slot",
                    nameSlot: "desMethosRes",
                },
                {
                    type: "input",
                    typeInput: "email",
                    placeholder: "someone@example.com",
                    name: "email",
                    showIconRequired: false,
                    label: `email`,
                    for: "input-email",
                    id: "input-email",
                    state: null,
                    textInvalid: "Please enter email",
                },
                {
                    type: "input-group",
                    typeInput: "number",
                    placeholder: "",
                    name: "phone",
                    label: `phone number`,
                    for: "input-phone",
                    id: "input-phone-personal",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    inputPhoneCountry: true,
                    state: null,
                    textInvalid: "Please enter phone",
                },
                {
                    type: "slot",
                    nameSlot: "birthDate"
                },
                {
                    type: "select",
                    label: `nationality`,
                    name: "nationality",
                    required: true,
                    for: "input-nationality-personal-detail",
                    id: "input-nationality-personal-detail",
                    idGroup: "input-group-nationality",
                    options: [],
                },
                {
                    type: "select",
                    label: `country of residence`,
                    name: "country_code",
                    required: true,
                    for: "input-country-personal-detail",
                    id: "input-country-personal-detail",
                    idGroup: "input-group-country",
                    options: [],
                },
            ],
            phoneNumbersFilter: phoneNumbers,
            textSearchPhoneNumber: "",
            menusAccount: [
                {
                    title: "Personal Details",
                    icon: "personal.png",
                    path: "/personal-detail",
                },
                { title: "My Numbers", icon: "my-numbers.png", path: "" },
                { title: "Manage Cards", icon: "card.png", path: "" },
                { title: "My Wallet", icon: "wallet.png", path: "" },
                { title: "Notifications", icon: "notification.png", path: "" },
                { title: "Recurring Games", icon: "recurring.png", path: "" },
            ],
            avatar: null,
            saving: false,
            saved: false,
            isOpenPopup: false,
            maxDateForm: moment().format("YYYY"),
        };
    },
    watch: {
        avatar: {
            handler: function () {
                this.saved = false;
            },
            deep: true,
        },
    },
    mounted() {
        this.getUserData();
    },
    created() {
        this.fetchDateCountries();
        this.fetDateAgo();
    },
    methods: {
        reloadAvatar() {
          this.getUserData();
        },
        fetDateAgo() {
            const nowYear = moment().format("YYYY");
            const nowMonthDate = moment().format("MM-DD");
            let yearAgo = `${parseInt(nowYear) - 18}-${nowMonthDate}`;
            this.maxDate = yearAgo;
            this.maxYearBirth = `${parseInt(nowYear) - 18}`;
        },

        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        togglePopupOptionsAvatar(data) {
            this.isOpenPopupOptionAvatar = data;
        },
        async sendOTP(isShowNoti) {
            let { email, code } = this.dataForm;

            let phone = this.dataForm.phone;
            let calling_code = `${code.replaceAll("\\+", "")}`;

            const urlApi = !isStrEmpty(email)
                ? AuthService.sendOTPToEmail("update_profile", email)
                : AuthService.sendOTPToPhone(
                      "update_profile",
                      phone,
                      calling_code
                  );

            try {
                const resp = await urlApi;

                if (resp.status === 200 && isShowNoti) {
                    this.showToast(
                        this.getTranslatedText(resp.message),
                        "success"
                    );
                }
            } catch (err) {
                console.log(err, "err");
            }
        },
        async onSubmitConfirmOTP(dataOTP) {
            const { code } = dataOTP;
            this.dataForm.code_otp = dataOTP.code;
            const { email, phone } = this.dataForm;
            this.isLoadingButtonOTP = true;
            const urlApi =
                this.dataForm.otp_by === "email"
                    ? AuthService.apiCheckOTPByEmail(
                          code,
                          "update_profile",
                          email
                      )
                    : AuthService.apiCheckOTPByPhone(
                          code,
                          "update_profile",
                          phone,
                          this.dataForm.calling_code.replaceAll("\\+", "")
                      );

            try {
                const resp = await urlApi;
                if (resp.status === 200) {
                    this.step = 1;
                    UserService.updateProfile(this.dataForm).then((res) => {
                        if (res.status === 200) {
                            this.getUserData();
                            this.dataForm.otp_by = "";
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "success"
                            );
                        } else {
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "error"
                            );
                        }
                    });
                } else {
                    this.showToast(
                        this.getTranslatedText(resp.message),
                        "error"
                    );
                }
                this.isLoadingButtonOTP = false;
            } catch (err) {
                console.log(err, "err");
            }
        },

        onClickGoBack() {
            this.step = 1;
        },
        toggleCamera() {
            if (this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },

        createCameraElement() {
            this.isLoading = true;

            const constraints = (window.constraints = {
                audio: false,
                video: true,
            });

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    this.isLoading = false;
                    this.$refs.camera.srcObject = stream;
                })
                .catch((error) => {
                    this.isLoading = false;
                    alert(
                        "May the browser didn't support or there is some errors."
                    );
                });
        },

        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

            tracks.forEach((track) => {
                track.stop();
            });
        },

        takePhoto() {
            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }

            this.isPhotoTaken = !this.isPhotoTaken;

            const context = this.$refs.canvas.getContext("2d");
            context.drawImage(this.$refs.camera, 0, 0, 131, 131);
            let canvas = document
                .getElementById("photoTaken")
                .toDataURL("image/png");
            canvas = canvas.replace(/^data:image\/(png|jpeg|jpg);base64,/, "");
            let formData = new FormData();
            const data = this.base64toBlob(canvas, "image/png");
            const start = Date.now();
            const avatarName = `${start}avatar.png`;
            const file = new File([data], avatarName, {
                lastModified: 1534584790000,
            });
            formData.append("file", file);
            this.stopCameraStream();
            UserAuthenticate.uploadAvatar(formData).then((res) => {
                if (res.status === 200) {
                    this.getUserData();
                    if(res.avatar) {
                        this.$store.dispatch("onChangeSrcAvatar", res.avatar);
                    }
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "success"
                    );
                    this.isCameraOpen = false;
                    setTimeout(() => {
                        this.togglePopupOptionsAvatar(false);
                    }, 500);
                    // this.isOpenPopupOptionAvatar = false;
                } else {
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "error"
                    );
                }
            });
        },

        base64toBlob(base64Data, contentType) {
            contentType = contentType || "";
            const sliceSize = 1024;
            const byteCharacters = atob(base64Data);
            const bytesLength = byteCharacters.length;
            const slicesCount = Math.ceil(bytesLength / sliceSize);
            const byteArrays = new Array(slicesCount);

            for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                const begin = sliceIndex * sliceSize;
                const end = Math.min(begin + sliceSize, bytesLength);

                const bytes = new Array(end - begin);
                for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }
            return new Blob(byteArrays, { type: contentType });
        },

        downloadImage() {
            const download = document.getElementById("downloadPhoto");
            const canvas = document
                .getElementById("photoTaken")
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            download.setAttribute("href", canvas);
        },
        changePassword() {
            this.$router.push({ name: "ChangePassword" });
        },
        async fetchDateCountries() {
            try {
                const resp = await countriesService.getCountries();
                if (resp.status === 200) {
                    const countries = resp.data.map(({ code, name }) => ({
                        value: code,
                        text: name,
                    }));
                    this.formItem[6].options = countries;
                    this.formItem[7].options = countries;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async getUserData() {
            try {
                const res = await UserService.getDataUser();
                if(res.avatar) {
                    this.$store.dispatch("onChangeSrcAvatar", res.avatar);
                }
                let index = phoneNumbers.findIndex(
                    (x) => x.number === `+${res.calling_code}`
                );

                const fullName = `${res.first_name + " " + res.last_name}`;
                const calling_code = `+${
                    res?.calling_code ||
                    phoneNumbers[0].number.replaceAll("\\+", "")
                }`;
                const phone = res.phone_number?.replaceAll(
                    `${res.calling_code}`,
                    ""
                ) || '';

                if(isStrEmpty(res.dob) && isStrEmpty(res.gender) && isStrEmpty(res.nationality) && isStrEmpty(res.country_code)) {
                    this.$store.state.isUpdateProfile = true
                } else {
                    this.$store.state.isUpdateProfile = false
                }
             

                this.dataForm.full_name = fullName;
                this.dataForm.gender = res.gender;
                this.dataForm.calling_code = calling_code;
                this.dataForm.code = "";
                this.dataForm.phone = phone;
                this.dataForm.email = res.email;
                this.dataForm.nationality = res?.nationality || '';
                this.dataForm.country_code = res?.country_code || '';
                this.dataForm.dob = res.dob
                this.formItem[5].valueDatepicker = moment(res.dob).format("YYYY-MM-DD")
                let userInfo = {
                    calling_code: calling_code,
                    email: res.email,
                    id: res.id,
                    name: fullName,
                    phone: res.phone_number,
                    address: res.address,
                    state: res.state,
                    city: res.city,
                    zipcode: res.zipcode,
                    country_code: res.country_code
                };
                setUserInfo(userInfo);

                if (index !== -1) {
                    this.dataForm.nameCountry = phoneNumbers[index].name;
                    this.dataForm.flag = phoneNumbers[index].flag;
                } else {
                    this.dataForm.nameCountry = phoneNumbers[0].name;
                    this.dataForm.flag = phoneNumbers[0].flag;
                }

                this.isLoadingPage = false;
            } catch (error) {
                console.log(error);
            }
        },
        uploadImage() {
            this.saving = true;
            setTimeout(() => this.savedAvatar(), 1000);
        },
        savedAvatar() {
            this.saving = false;
            this.saved = true;
        },
        handleLogout() {
            this.$store.dispatch("handleLogout");
            this.$router.push("/login");
        },

        handleClickAccountItem(path) {
            this.isOpenPopup = false;
            document.getElementById("idNavigation").style.height = "0%";
            this.$router.push(path);
        },
        // call api check email and phone
        async onBurInputFormData(event, phoneCode) {
            const { name, value } = event.target;
            let { calling_code, phone, email } = this.dataForm;

            if (name === "email" && isStrEmpty(value) && !isStrEmpty(phone)) {
                this.dataForm.email = "";
            }

            if (name === "phone" && isStrEmpty(value) && !isStrEmpty(email)) {
                this.dataForm.phone = "";
            }

            switch (true) {
                case name === "email" &&
                    isStrEmpty(value) &&
                    !isStrEmpty(phone) &&
                    this.formItem[3].state !== null:
                    this.formItem[3].state = null;
                    break;
                // check phone no empty
                case this.formItem[3].state !== null &&
                    name === "phone" &&
                    isStrEmpty(email) &&
                    !isStrEmpty(value):
                    this.formItem[3].state = null;
                    this.dataForm.phone = value;
                    break;
                // check email empty but phone no empty
                case this.formItem[3].state !== null &&
                    name === "email" &&
                    value === "" &&
                    !isStrEmpty(phone):
                    this.formItem[3].state = null;
                    this.dataForm.email = "";
                    break;
                // check Incorrect email format
                case name === "email" &&
                    !isStrEmpty(value) &&
                    !validateEmail(value):
                    this.formItem[3].state = false;
                    this.formItem[3].textInvalid = this.getTranslatedText(
                        "correct email format"
                    );
                    this.dataForm.email = value;
                    break;
                // check email already exist
                case name === "email" &&
                    validateEmail(value) &&
                    value !== email &&
                    value !== "":
                    try {
                        this.isDisabledBtnSave = true;
                        const res = await authService.checkMail(value);

                        if (res.status === 200) {
                            this.isDisabledBtnSave = false;
                            this.dataForm.otp_by = "email";
                            this.isChangedEmail = true;
                        }

                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItem[3].state = false;
                            this.formItem[3].textInvalid = message;
                        } else {
                            this.formItem[3].state = null;
                        }
                        this.dataForm.email = value;
                        this.isDisabledBtnSave = false;
                    } catch (error) {
                        this.formItem[3].textInvalid = error;
                        this.isDisabledBtnSave = false;
                    }
                    break;
                // check phone already exist and change code phone
                case (name === "phone" && value !== phone && value !== "") ||
                    !isStrEmpty(phoneCode):
                    // calling_code check change code phone

                    calling_code = !isStrEmpty(phoneCode)
                        ? phoneCode.replaceAll("\\+", "")
                        : calling_code.replaceAll("\\+", "");

                    try {
                        this.isDisabledBtnSave = true;
                        const res = await authService.checkPhone(
                            calling_code,
                            value
                        );
                        if (res.status === 200) {
                            console.log(this.isChangedEmail, 'isChangedEmail')
                            if (this.isChangedEmail === false) {
                                this.dataForm.otp_by = "phone";
                            } else {
                                this.dataForm.otp_by = "email";
                            }
                            this.isDisabledBtnSave = false;
                        }

                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItem[4].state = false;
                            this.formItem[4].textInvalid = message;
                        } else {
                            this.formItem[4].state = null;
                        }
                        this.dataForm.phone = value;
                        this.isDisabledBtnSave = false;
                    } catch (error) {
                        this.formItem[3].textInvalid = error;
                        this.isDisabledBtnSave = false;
                    }
                    break;

                default:
                    break;
            }
        },

        updateDate(date) {
            let dateFormat = date.split('.')

            let valueConvert = `${dateFormat[2]}/${dateFormat[1]}/${dateFormat[0]}`

            let dateFormatUTC = moment(valueConvert).format('MM/DD/YYYY')

            if (!isStrEmpty(this.textInvalidFeedbackDate) && moment(dateFormatUTC).format("YYYY-MM-DD") <= moment(this.maxDate).format("YYYY-MM-DD")) {
                this.textInvalidFeedbackDate = ''
            } 
            this.dataForm.dob = dateFormatUTC
        },

        // update data resgister
        updateFormData(item) {
            let { value, name, isSelectDate } = item; 
            
            if (name !== "email" && name !== "phone") {
                this.dataForm[name] = value;
            }
            
            if(isSelectDate || name === 'dob') {
                this.formItem[5].state = true
            }
        },

        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone,
                        name: "phone",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
        },

        onSubmitForm(type) {
            if (this.dataForm.email === "" && this.dataForm.phone === "") {
                this.formItem[3].state = false;
                this.formItem[3].textInvalid = "Please enter email";
                return false;
            } else {
                this.formItem[3].state = true;
            }

            if (
                this.formItem[3].state === false ||
                this.formItem[4].state === false
            ) {
                this.showToast(
                    this.getTranslatedText("Please update data", "warning")
                );
                return false;
            }

            if (moment(this.dataForm.dob).isValid() && moment(this.dataForm.dob).format("YYYY-MM-DD") > moment(this.maxDate).format("YYYY-MM-DD")) {
                this.textInvalidFeedbackDate = 'age should be more than 18 years. please enter a valid date of birth'
                return false
            }

            if (this.dataForm.otp_by === "phone") {
                AuthService.sendOTPToPhone(
                    "update_profile",
                    this.dataForm.phone,
                    this.dataForm.calling_code.replaceAll("\\+", "")
                ).then((res) => {
                    if (res.status === 200) {
                        this.step = 2;
                        if (type === "resend") {
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "success"
                            );
                        }
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            }

            if (this.dataForm.otp_by === "email") {
                AuthService.sendOTPToEmail(
                    "update_profile",
                    this.dataForm.email
                ).then((res) => {
                    if (res.status === 200) {
                        this.step = 2;
                        if (type === "resend") {
                            this.showToast(
                                this.getTranslatedText(res.message),
                                "success"
                            );
                        }
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            }

            if (this.dataForm.otp_by === "") {
                let dataConver = {...this.dataForm}
                UserService.updateProfile(dataConver).then((res) => {
                    if (res.status === 200) {
                        this.dataForm.otp_by = "";
                        this.getUserData();
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "success"
                        );
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                });
            }
        },

        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },

        onShowBottomMenuList() {
            this.$refs.bottomMenuList.open();
        },
        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
        },
        handleClickRedirect(item) {
            if (this.$store.state.is_app && item.isRedirect) {
                redirectPathApp(item.url);
            } else {
                this.routerPush(item.url);
            }
        },
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/personal-detail/_personal-detail.scss"
/>
